import { motion } from "framer-motion";
import { Award, Presentation, Users, Star } from "lucide-react";
import { STATS } from "@/lib/content";
import { Reveal } from "@/components/landing/Reveal";

const iconMap = { award: Award, presentation: Presentation, users: Users, star: Star };

export const StatsBand = () => (
  <section className="relative px-4 pb-6 pt-14 sm:px-8 lg:pt-16" data-testid="stats-section">
    <div className="mx-auto max-w-6xl">
      <Reveal>
        <div className="relative overflow-hidden rounded-[1.75rem] border border-surfaceline bg-surface p-6 sm:p-8">
          <div className="pointer-events-none absolute -right-16 -top-16 h-52 w-52 rounded-full bg-em1/12 blur-[70px]" />
          <div className="relative z-10 grid grid-cols-2 gap-y-8 sm:grid-cols-4">
            {STATS.map(({ icon, value, label }, i) => {
              const Icon = iconMap[icon];
              return (
                <div
                  key={label}
                  data-testid={`stat-${i}`}
                  className={`flex flex-col items-center px-2 text-center sm:px-4 ${
                    i !== 0 ? "sm:border-l sm:border-surfaceline" : ""
                  }`}
                >
                  <div className="mb-3 flex h-11 w-11 items-center justify-center rounded-xl border border-gold/30 bg-ink text-gold">
                    <Icon size={20} />
                  </div>
                  <motion.span
                    initial={{ opacity: 0, y: 12 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ delay: i * 0.08, duration: 0.5 }}
                    className="font-display text-4xl font-bold leading-none text-em2 sm:text-5xl"
                  >
                    {value}
                  </motion.span>
                  <span className="mt-2 text-xs font-semibold uppercase tracking-wider text-mutedgreen sm:text-sm">
                    {label}
                  </span>
                </div>
              );
            })}
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
